let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lHw2B")).then(() => parcelRequire('eRvGI'));